export const hintSizes = {
   ExtraSmall: {
      containerClassName: 'mt-6px',
      errorText: {
         containerClassName: 'text-xs-regular'
      },
      hintText: {
         containerClassName: 'text-xs-regular'
      }
   },
   Small: {
      containerClassName: 'mt-6px',
      errorText: {
         containerClassName: 'text-sm-regular'
      },
      hintText: {
         containerClassName: 'text-sm-regular'
      }
   },
   Medium: {
      containerClassName: 'mt-6px',
      errorText: {
         containerClassName: 'text-sm-regular'
      },
      hintText: {
         containerClassName: 'text-sm-regular'
      }
   }
}
